/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Notifications récentes dans l\'application',
    titleMeta: 'Affichage des notifications récentes dans l\'application CamAPS FX',
    descriptionMeta: 'Voici le texte des récentes notifications intégrées à l\'application concernant les mises à jour de l\'application, les avis de sécurité, les mises à jour du manuel d\'utilisation',
    keywords: 'Notifications' ,
    localeMeta: 'fr_fr',

    heading: 'Notifications récentes dans l\'application',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Mise à jour de l\'application Android (YpsoPump only) 28/10/2026',
    body_132:'Cher utilisateur de CamAPS FX, une nouvelle version de l\'application 1.4(195) sera disponible dans les prochains jours. Veuillez choisir votre heure de mise à jour préférée en désactivant la mise à jour automatique pour CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client mylife-Diabetescare.',

    header_131:'',
    body_131:'',

    header_130:'Mise à jour requise (YpsoPump uniquement) 20/10/2026',
    body_130:'Mise à jour requise ! Cette version de CamAPS FX peut planter et redémarrer plus fréquemment. Veuillez effectuer la mise à jour vers la dernière version DÈS MAINTENANT via le Google Play Store. La version 1.4(190) de l\'application sera abandonnée le 20/11/2026. Après cette date, Mode auto ne sera plus disponible tant que l\'application n\'aura pas été mise à jour. L\'administration d\'insuline via votre pompe se poursuivra.',

    header_129:'Mise à jour de l\'application iOS (YpsoPump only) 19/10/2026',
    body_129:'Cher utilisateur de CamAPS FX, une NOUVELLE VERSION de l\'application 1.4(196) sera disponible dans les prochains jours. DÉSACTIVEZ LES MISES À JOUR AUTOMATIQUES DE CamAPS FX dans l\'App Store pour choisir votre moment de mise à jour préféré. Si vous avez des questions, veuillez contacter le service client de mylife-Diabetescare.',

    header_128:'',
    body_128:'',

    header_127:'',
    body_127:'',

    header_126:'',
    body_126:'',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'',
    body_122:'',

    header_121:'Sortie Apple iOS 27 11/09/2026',
    body_121:'Apple va bientôt lancer iOS 27. Afin de garantir une utilisation ininterrompue de l\'application CamAPS FX, veuillez vérifier la compatibilité de votre smartphone et de votre système d\'exploitation sur le site du fabricant du capteur AVANT de mettre à jour votre iPhone vers iOS 27. Les mises à jour automatiques peuvent être ACTIVÉES par défaut dans les paramètres de votre téléphone; veuillez envisager de les DÉSACTIVER.',

    header_120:'',
    body_120:'',

    header_119:'',
    body_119:'',

    header_118:'',
    body_118:'',

    header_117:'Mise à jour de l\'application Android (YpsoPump only) 31/08/2026',
    body_117:'Cher utilisateur de CamAPS FX, une nouvelle version de l\'application 1.4(193) sera disponible dans les prochains jours. Veuillez choisir votre heure de mise à jour préférée en désactivant la mise à jour automatique pour CamAPS FX dans le Google Play Store. Si vous avez des questions, veuillez contacter le service client mylife-Diabetescare.',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'',
    body_111:'',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Version Android OS 17 24/06/2026',
    body_109:'Android publiera prochainement OS 17. Afin de garantir une utilisation ininterrompue de l\'application CamAPS FX, veuillez vérifier la compatibilité de votre smartphone et de votre système d\'exploitation sur le site du fabricant du capteur AVANT de mettre à jour votre appareil Android vers OS 17. Les mises à jour automatiques peuvent être ACTIVÉES par défaut dans les paramètres de votre téléphone; veuillez les DÉSACTIVER.',

    header_108:'',
    body_108:'',

    header_107:'',
    body_107:'',

    header_106:'',
    body_106:'',

    header_105:'',
    body_105:'',

    header_104:'',
    body_104:'',

    header_103:'',
    body_103:'',

    header_102:'',
    body_102:'',

    header_101:'',
    body_101:'',

    header_100:'',
    body_100:'',

    header_99:'',
    body_99:'',

    header_98:'',
    body_98:'',

    header_97:'',
    body_97:'',

    header_96:'',
    body_96:'',

    header_95:'',
    body_95:'',

    header_94:'',
    body_94:'',

    header_93:'',
    body_93:'',

    header_92:'',
    body_92:'',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'',
    body_89:'',

    header_88:'',
    body_88:'',

    header_87:'',
    body_87:'',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'Mise à jour du manuel de l’utilisateur (Ypsopump uniquement) 25/02/2026',
    body_85:'Une version mise à jour du manuel de l’utilisateur est maintenant disponible. Vous pouvez y accéder à partir du menu principal de CamAPS FX en sélectionnant Aide.',

    header_84:'Disponibilité de FreeStyle Libre 3 Pus et iOS (YpsoPump uniquement 23/02/2026)',
    body_84:'Le capteur FreeStyle Libre 3 Plus est maintenant compatible avec l’application CamAPS FX au Canada. Pour voir cette option dans l’application, veuillez associer de nouveau votre pompe mylife YpsoPump à l’application CamAPS FX. CamAPS FX est maintenant aussi disponible sur iPhone. Pour toute question, communiquez avec le Service à la clientèle mylife Diabetescare.',

    header_83:'Mise à jour de l\'application Android (Ypsopump uniquement) 16/02/2026',
    body_83:'Cher utilisateur de CamAPS FX, une NOUVELLE VERSION de l\'application sera disponible au cours des prochains jours – 1.4(190). DÉSACTIVEZ LES MISES À JOUR AUTOMATIQUES de CamAPS FX dans le Google Play Store afin de choisir le moment de mise à jour qui vous convient. Pour des raisons de cybersécurité, les versions INFÉRIEURES à 1.4(190) seront DISCONTINUÉES le 31 mars. Si vous avez des questions, veuillez communiquer avec le service à la clientèle de mylife-Diabetescare.',

    header_82:'',
    body_82:'',

    header_81:'',
    body_81:'',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'',
    body_77:'',

    header_76:'Annonce Dexcom de mylife-Diabetescare (YpsoPump seulement) 15/12/2025',
    body_76:'Dexcom a annoncé qu\'elle retirera progressivement le Dexcom G6 du marché afin ' +
        'd\'évoluer vers le nouveau Dexcom G7. Pour l\'instant, votre G6 demeure entièrement ' +
        'pris en charge, aucune action n\'est requise. Vous continuerez d\'avoir des options ' +
        'de capteurs à mesure que la technologie évolue. Si vous avez des questions, nous sommes là pour vous aider.',

    header_75:'',
    body_75:'',

    header_74:'',
    body_74:'',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'',
    body_72:'',
    body_72_link_text:'',
    body_72_end: '',
    body_72_link:'',

    header_71:'',
    body_71:'',
    body_71_link_text:'',
    body_71_end: '',
    body_71_link:'',

    header_70:'',
    body_70:'',
    body_70_link_text:'',
    body_70_end: '',
    body_70_link:'',
	
    header_69:'',
    body_69:'',
	
    header_68:'',
    body_68:'',
	
    header_67:'',
    body_67:'',
	
    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',

    header_62:'',
    body_62:'',
    body_62_link_text:'',
    body_62_end: '',
    body_62_link:'',

    header_61:'',
    body_61:'',

    header_60:'',
    body_60:'',

    header_59:'',
    body_59:'',

    header_58:'',
    body_58:'',

    header_57:'',
    body_57:'',

    header_56:'',
    body_56:'',

    header_55:'Android OS 16 15/08/2025',
    body_55:'Note: CamAPS FX n\'est pas actuellement compatible avec Android OS 16. Pour garantir une utilisation ininterrompue de l\'application, veuillez consulter la FAQ sur camdiab.com/fr-ca afin de vérifier la compatibilité de votre téléphone intelligent et de votre système d\'exploitation avant de procéder à la mise à jour vers Android OS 16. Attention: les mises à jour automatiques pourraient être activées par défaut dans les paramètres de votre téléphone.',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
	header_52:'',
    body_52:'',
	
	header_51:'',
    body_51:'',

    header_50:'Avis important de compatibilité (Android & Canada uniquement) 14/07/2025',
    body_50:'Une nouvelle version de mylife CamAPS FX 1.4 (189) est disponible. Veuillez mettre l’application à jour via le Play Store. ' +
'Nous vous recommandons de ne pas mettre à jour votre téléphone vers le système d’exploitation OS 16 — il n’est pas encore pris en charge et pourrait entraîner des problèmes de connexion avec Glooko.',

    header_49:'',
    body_49:'',

    header_48:'',
    body_48:'',

    header_47:'',
    body_47:'',

    header_46:'',
    body_46:'',

    header_45:'',
    body_45:'',

    header_44:'',
    body_44:'',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',
	
    header_41:'',
    body_41:'',

    header_40:'',
    body_40:'',

    header_39:'',
    body_39:'',

    header_38:'',
    body_38:'',

    header_37:'',
    body_37:'',

    header_36:'',
    body_36:'',

    header_35:'',
    body_35:'',

    header_34:'',
    body_34:'',

    header_33:'',
    body_33:'',

    header_32:'',
    body_32:'',

    header_31:'',
    body_31:'',

    header_30:'',
    body_30:'',

    header_29:'',
    body_29:'',

    header_28:'',
    body_28:'',

    header_27:'',
    body_27:'',

    header_26:'',
    body_26:'',

    header_25:'',
    body_25:'',

    header_24:'',
    body_24:'',

    header_23:'',
    body_23:'',

    header_22:'',
    body_22:'',

    header_21:'',
    body_21:'',

    header_20:'',
    body_20:'',

    header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',

    header_17:'',
    body_17:'',

    header_16:'',
    body_16:'',

    header_15:'',
    body_15:'',

    header_14:'',
    body_14:'',

    header_13:'',
    body_13:'',
    body_13_link_text:'',
    body_13_end: '',
    body_13_link:'',

    header_12:'',
    body_12:'',

    header_11:'',
    body_11:'',

    header_10:'',
    body_10:'',

    header_9:'',
    body_9:'',

    header_8:'',
    body_8:'',

    header_7:'',
    body_7:'',

    header_6:'',
    body_6:'',

    header_5:'',
    body_5:'',

    header_4:'',
    body_4:'',

    header_3:'',
    body_3:'',

    header_2:'',
    body_2:'',

    header_1:'',
    body_1:'',

};
